import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";
import i18next from "i18next";
import { I18nextProvider } from "react-i18next";
import { BrowserRouter } from "react-router-dom";
import "react-pagination-bar/dist/index.css";
import "react-modern-drawer/dist/index.css";
import ErrorBoundary from "./ErrorBoundry";
import { Provider } from "react-redux";
import store from "redux/store/store";
import { BrandsConfigProvider } from "utils/v2/BrandsConfig/BrandsConfigProvider";
import i18n from "./i18n";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

const gtmScriptElement = document.createElement("script");
const gtmScriptContent = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
              new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','${process.env.REACT_APP_GTAG_ID}');`;
gtmScriptElement.textContent = gtmScriptContent;
document.head.appendChild(gtmScriptElement);
const noscriptElement = document.createElement("noscript");

const noscriptContent = `
  <iframe src="https://www.googletagmanager.com/ns.html?id=${process.env.REACT_APP_GTAG_ID}"
          height="0" width="0" style="display:none;visibility:hidden"></iframe>
`;
noscriptElement.innerHTML = noscriptContent;
document.body.appendChild(noscriptElement);

root.render(
  <StrictMode>
    <ErrorBoundary>
      <Provider store={store}>
        <I18nextProvider i18n={i18n}>
          <BrowserRouter>
            <BrandsConfigProvider>
              <App />
            </BrandsConfigProvider>
          </BrowserRouter>
        </I18nextProvider>
      </Provider>
    </ErrorBoundary>
  </StrictMode>,
);

serviceWorkerRegistration.register();

reportWebVitals();
